import { breakpoints, Button, ProductCard } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const StyledProductCard = styled(ProductCard)`
  margin-top: 1rem;
`;

export const AddToCartButtonWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: center;

  & > button,
  form button {
    text-transform: none !important;
    width: auto !important;
  }
`;

export const AddToCartButtonWrapperFullWidth = styled(AddToCartButtonWrapper)`
  width: 100%;

  & > button,
  form button {
    width: 100% !important;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 1rem;
  line-height: 1.4;
  padding: 0.4375rem 1rem;
  text-transform: none;
  white-space: pre-wrap;
  min-height: 2.25rem;
  height: auto;
  @media (min-width: ${breakpoints.sm}) {
    width: auto;
  }
`;

export const StyledButtonFullWidth = styled(StyledButton)`
  width: 100%;
`;

export const CouponIcon = styled.img`
  width: 2.5rem;
  height: 0.5rem;
  z-index: 2;
`;
